import React from 'react';
import './Loading.css';
import SquareButton from '../button/SquareButton';


type ErrorProps = {
    text?: string;
}
const Error: React.FC<ErrorProps> = ({text = 'データの読み込みに失敗しました。ブラウザを再読み込みしてください。'}) => {
    return (
        <div className="error-container">
          <p>{ text }</p>
          <SquareButton onClick={() => { window.location.reload(); }} label={'再読み込み'} color='red' />
        </div>
    );
};

export default Error;
